import * as index from './index';
index.LinearGauge.Inject(index.GaugeTooltip, index.Annotations, index.Print, index.PdfExport, index.ImageExport, index.Gradient);
export * from './index';
